import React from "react";

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return error?.name === "ChunkLoadError"
      ? { hasError: true }
      : null;
  }

  componentDidCatch(error) {
    if (error?.name === "ChunkLoadError") {
      console.warn("Chunk load failed. Reloading...");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return <div>Reloading application...</div>;
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
